export enum BusinessName {
  ALL = 'ALL',
  TV = 'TV',
  FIJO = 'FIJO',
  UNKNOWN = 'UNKNOWN',
}

export enum DashboardRoutePath {
  ACTIVACIONES = '/dashboard/',
  CLARO_TV = '/claro-tv',
  PDF = '/pdf',
  REPORTES = '/dashboard/reports',
}

export interface Entity {
  id: string;
  commercialName: string;
  channelType: string;
  documentNumber: string;
  isEmployee?: boolean;
  business?: BusinessName;
}

export interface GetEntitiesResponse {
  activity: string;
  entities: Entity[];
  debtAuthorized: boolean;
}

export interface SellerInfo {
  name: string;
  surname: string;
  documentNumber: string;
  creditLimit: string;
  salesPlace: string;
  status: string;
  description: string;
}

export interface SellerInfoResponse {
  seller: SellerInfo;
}

export enum ChannelType {
  Direct = 'D',
  Indirect = 'I',
}
